module.exports = __webpack_public_path__ + "img/vi.202551dc.png";